const AUTO_LIABILITY_INDICATORS_DICT = {
  probable_liability: 'Probable Liability',
  questionable_liability: 'Questionable Liability',
  doubtful_liability: 'Doubtful Liability',
} as const;

export default AUTO_LIABILITY_INDICATORS_DICT;
